import { Component, OnInit } from '@angular/core';
import { SearchLineService } from './app-search-line.service';
@Component({
  selector: 'app-search-line',
  templateUrl: './app-search-line.component.html',
  styleUrls: ['./app-search-line.component.css'],
})

export class SearchLineComponent implements OnInit {
  constructor(private service: SearchLineService){}
  public PhoneNumber= '';
  public numero:string = "";
  public numarray:any = {};
  public name:any = '';
  public type:any = '...';

  ngOnInit()
  {

  }

  GetandSearch(num:any)
  {
    this.numero = num;

    this.numarray= {
      search:this.numero
    };

    this.service.search(this.numarray).subscribe((response:any)=>{
      console.log(response);
      this.name = response.name;
      this.type = response.searchType;
    });
  
    this.PhoneNumber= '';
    this.name = '';
    this.type = '...';
  }



}


// WEBPACK FOOTER //
// ./src/app/components/app-search-line/app-search-line.component.ts